import secureLocalStorage from "react-secure-storage";

import * as React from 'react';
import '../../Styles/RiskViews.scss';
import Images from "../../Assets/Images";
import { Grid, GridColumn, GridDetailRow} from '@progress/kendo-react-grid';
import CurrencyFormat from './Component/CurrencyFormat';
import { formatNumber } from '@telerik/kendo-intl';
import { Renderers } from './Renderers';
import NewApprovedCheckBox from './NewApprovedCheckBox';
import MitigationNameCell from './Component/MitigationNameCell';

const checkBoxata = [
    { text: "yes", value: true },
    { text: "no", value: false },
  ];


export class MitigationExpandForScenaio extends GridDetailRow {
 
   constructor(props) {
        super(props);
        this.state = {
            data:[],
            editField: undefined,
            changes: false
        };

       this.renderers = new Renderers(this.enterEdit, this.exitEdit, 'inEdit');
    }
  
  createDynamicColsInMitigation = async (products) => {
    let impactColumn = [];
    let impactMaster = [];
    if (products && products.length > 0) {
      impactMaster = products[0].impactResponse;
    }
    products.map((res, i) => {
      if (res.impactResponse) {
        res.impactResponse.map((item, j) => {
          if (impactColumn.length > 0) {
            if (!impactColumn.includes(item.name)) {
              impactColumn.push(item.name);
            }
          } else {
            impactColumn.push(item.name);
          }
        });
      }
    });
    
    if (impactColumn.length > 0) {
      products.map((res) => {
        impactColumn.map((col) => {
          let temp = res.impactResponse.filter((item) => item.name === col);
          if (temp.length > 0) {
            res[col] = temp[0].value;
          } else {
            res[col] = undefined;
          }
        });
      });
    }
    let columnsToShow = [];
    if (impactColumn.length > 0) {
      columnsToShow = impactColumn.map((item, index) => (
        <GridColumn
          key={ index }
          field={ item }
          title={this.getImpactUnit(item,impactMaster)}
              width="100px"
              editable={false}
          cell={ (props) => (<CurrencyFormat { ...props } onEditCell={this.onEditCell}/>) }
        />
      ));
    }
    if (!this.state.impactMitigationColumns) {

      products.map((riskReg) => {
        if (riskReg.actualCompletionDate) {
          riskReg.actualCompletionDate = new Date(riskReg.actualCompletionDate);

        }
        if (riskReg.createdDate) {
          riskReg.createdDate = new Date(riskReg.createdDate);
         

        }
        if (riskReg.originalCompletionDate) {
          riskReg.originalCompletionDate = new Date(riskReg.originalCompletionDate);

        }
        if (riskReg.projectedCompletionDate) {
          riskReg.projectedCompletionDate = new Date(riskReg.projectedCompletionDate);

        }
      })
      this.setState({ ...this.state, impactMitigationColumns: columnsToShow, data: products });
    }


  };

  onEditCell=()=>{
    
  }
  getImpactUnit = (impact,impactMaster) => {
    var impactTemp = impactMaster.find(
      (item) => item.name == impact
    );
    var res = impact;
    if (impactTemp && impactTemp.name) {
      let unit=impactTemp.units?" / "+impactTemp.units:""
      res = impactTemp.name + unit;
    }
    if (this.props.dataItem.isOpportunity === "Opportunity") {
      return "Increase in " + res;
    } else {
      return "Reduction in " + res;
    }
  };
  enterEdit = (dataItem, field) => {
    
        const data = this.state.data.map(item => ({
                ...item,
                inEdit: item.riskRegisterActionId === dataItem.riskRegisterActionId ? field : undefined
            })
        );

        this.setState({
            data,
            editField: field
        });
    }

    exitEdit = () => {
        const data = this.state.data.map(item => (
            { ...item, inEdit: undefined }
        ));

        this.setState({
            data,
            editField: undefined,
        });
    }

    
  itemChange = (event) => {
        event.dataItem[event.field] = event.value;
        this.setState({
            changes: true
        });
    }
  closeEditandSaveMitigation = async (data) => {
    try {
        this.setState({ editID: null, enterEditFlag: false });
      this.props.refreshRiskList(data);
      
    } catch (error) {
      console.error(error);
    }
  };
  approvedCell = (event) => { 
    return <td>{ event.dataItem.approved?'Yes':'No'}</td>
  }
  
 
  manageButton = (event) => {
    let eventData = event.dataItem;
    return (
      <td className="k-grid-content-sticky editBtns">
        <ul className="actionIcon">
          <li>
            { this.state.enterEditFlag && eventData.riskRegisterActionId == this.state.editID ? (
              <a
                title="Save"
                onClick={ () => this.closeEditandSaveMitigation(eventData) }
                className="greenbtn icon"
              >
                <img src={ Images.CHECKGREEN } width="10" alt="update" />
              </a>
            ) : (
                <a
                  title="Edit"
                  onClick={ () => this.rowClick(eventData) }
                  className="greenbtn icon"
                >
                  <img src={ Images.EDITICON } width="10" alt="edit" />
                </a>
              ) }
          </li>
        </ul>
      </td>
    );
  };


  render() {
    const data = this.props.dataItem.mitigationResps;
    if (data) {
      this.createDynamicColsInMitigation(data);
      return (
        <div className="riskReportMitigation" id="#analyticsaction" >
          {/* <Grid
            // data={data}

            data={ this.state.data.map((item) =>
              ({ ...item, inEdit: item.riskRegisterActionId === this.state.editID })
            ) }
            reorderable
            resizable
            editField="inEdit"

            onRowClick={this.rowClick}
            onItemChange={ this.itemChange }
          > */}
          <Grid
            // style={{ height: '420px' }}
            data={this.state.data}
            // rowHeight={50}
            onItemChange={this.itemChange}
            cellRender={this.renderers.cellRender}
            rowRender={this.renderers.rowRender}
            editField="inEdit"
            resizable
            reorderable
          >
            {/* <GridColumn cell={ this.manageButton } width="40px" /> */}

            <GridColumn
              field="approved"
              title="Base line approval status"
              width="120px"
              // editable={true}
              // // cell={ CheckBox }
              // editor="boolean"
              cell={this.approvedCell}
            />
            <GridColumn
              field="newApproval"
              title="New approval status"
              width="120px"
              cell={(props) => (
                <NewApprovedCheckBox
                  {...props}
                  dropDownData={checkBoxata}
                  onEditCell={this.enterEdit}
                  updateDropdownValue={this.closeEditandSaveMitigation}
                />
              )}
            />
            <GridColumn
              field="name"
              title="Action Title"
              width="120px"
              locked={true}
              editable={false}
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.enterEdit} />
              )}
            />
           <GridColumn
            field="createdDate"
            title="created Date"
            editable={false}
            format="{0:dd-MMM-yyyy}"
            width="120px"
            />
             <GridColumn
            field="createdByName"
            title="created By"
            editable={false}
            width="120px"
            />
            <GridColumn
              field="number"
              title="Action Number"
              width="150px"
              locked={true}
              editable={false}
            />
            <GridColumn
              field="control"
              title="Description"
              width="150px"
              editable={false}
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.enterEdit} />
              )}
            />
            <GridColumn
              field="externalReference"
              title="External Reference"
              width="150px"
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
            />
            <GridColumn
              field="actionType"
              title="Action Type"
              width="150px"
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
            />
            <GridColumn
              field="cost"
              title={"Cost of Action / " + secureLocalStorage.getItem("currency")}
              width="80px"
              editable={false}
                cell={(props) => <td>{formatNumber(props.dataItem.cost, "##,#")}</td>}
            />
            <GridColumn
              field="reductionFrequency"
              title={
                this.props.dataItem.isOpportunity === "Opportunity"
                  ? "Increase in Probability (%)"
                  : "Reduction in Probability (%)"
              }
              width="120px"
              editable={false}
              //   cell={ (props) => (<CurrencyFormat { ...props } />) }
            />
            {this.state.impactMitigationColumns}
            <GridColumn
              field="spi"
              title="% On Track"
              width="150px"
              editable={false}
            />
            <GridColumn
              field="percentageCompletion"
              title="% Completion"
              width="150px"
            />
            <GridColumn
              field="originalCompletionDate"
              title="Original Completion Date"
              width="150px"
              editable={false}
              format="{0:dd-MMM-yyyy}"
            />
            <GridColumn
              field="projectedCompletionDate"
              title="Projected Completion Date"
              width="150px"
              editable={false}
              format="{0:dd-MMM-yyyy}"
            />
            <GridColumn
              field="actualCompletionDate"
              title="Actual Completion Date"
              width="150px"
              //   editor="date" format="{0:d}"
              editable={false}
              format="{0:dd-MMM-yyyy}"
            />
            <GridColumn
              field="departments"
              title="Departments"
              width="150px"
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
            />
            <GridColumn
              field="externalStatus"
              title="External Status"
              width="120px"
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
            />
            <GridColumn
              field="weeklyReport"
              title="Weekly Report"
              width="100px"
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
            />
          </Grid>
        </div>
      );
    }
    return (
      <div style={ { height: "50px", width: '100%' } }>
        <div style={ { position: 'absolute', width: '100%' } }>
          <div className="k-loading-image" />
        </div>
      </div>
    );
  }
}
